export default __webpack_public_path__ + "images/FQ.af41d08.png";